import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

export function DealValue({ deal, fields, isUrl, label, name, value }) {
  value = value == null ? deal[name] : value;

  if (!value || !fields[name] || fields[name].hidden) {
    return null;
  }

  if (isUrl) {
    value = <div className="d-flex flex-column">
      {value.split(/[\s,]+/).map((url, i) => {
        url = url.replace(/https?:\/\//, '');
        return <a href={`//${url}`} key={i} rel="noopener noreferrer" target="_blank">{url}</a>;
      })}
    </div>;
  }

  return (
    <tr>
      <th className="bg-transparent py-1 px-0">{label || fields[name].label}</th>
      <td className="bg-transparent py-1 px-0">{value}</td>
    </tr>
  );
}

DealValue.propTypes = {
  deal: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  isUrl: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
};

const mapStateToProps = state => ({
  deal: state.deal,
  fields: state.fields,
});

export default connect(mapStateToProps)(DealValue);
